// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1aChd","col":"styles_col__2bqrq"};